import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import '../styles/Header.css';

const Header = () => {
  const [showContactModal, setShowContactModal] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const menuRef = useRef(null);
  const burgerRef = useRef(null);

  const openContactModal = () => {
    setShowContactModal(true);
  };

  const closeContactModal = () => {
    setShowContactModal(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        isMenuOpen &&
        menuRef.current &&
        !menuRef.current.contains(event.target) &&
        !burgerRef.current.contains(event.target)
      ) {
        setIsMenuOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isMenuOpen]);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <>
      <header className="header">
        <div className="container">
          <div className="logo">
            <div className="logo-container">
              <Link to="/">
                <img src="/img/logoFdp.webp" alt="FDP AUTOMOBILES" className="logo-image" />
              </Link>
              <h1>FDP AUTOMOBILES</h1>
            </div>
          </div>
          <button 
            ref={burgerRef}
            className={`burger-menu ${isMenuOpen ? 'open' : ''}`} 
            onClick={toggleMenu}
            aria-label="Menu"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>

          <nav className={`nav ${isMenuOpen ? 'nav-open' : ''}`} ref={menuRef}>
            <ul className="nav-list">
              <li>
                <Link to="/" className="nav-link" onClick={() => setIsMenuOpen(false)}>
                  Accueil
                </Link>
              </li>
              <li>
                <Link to="/stock" className="nav-link" onClick={() => setIsMenuOpen(false)}>
                  Notre Stock
                </Link>
              </li>
              <li className="desktop-only">
                <button 
                  onClick={() => {
                    openContactModal();
                    setIsMenuOpen(false);
                  }} 
                  className="nav-link contact-btn"
                >
                  Nous Contacter
                </button>
              </li>
            </ul>
          </nav>
        </div>
      </header>

      {/* Modal de contact */}
      {showContactModal && (
        <div className="modal-overlay" onClick={closeContactModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <div className="modal-logo">
                <img src="/img/logoFdp.webp" alt="FDP AUTOMOBILES" className="modal-logo-img" />
                <h2>Contactez FDP AUTOMOBILES</h2>
              </div>
              <button className="modal-close" onClick={closeContactModal}>×</button>
            </div>
            
            <div className="modal-body">
              <div className="contact-intro">
                <p>Votre partenaire de confiance depuis plus de 45 ans</p>
                <div className="contact-badges">
                  <span className="badge">🇫🇷 Français</span>
                  <span className="badge">🏆 45 ans d'expérience</span>
                  <span className="badge">
                    <img src="/img/LaVoiture.png" alt="Voiture" className="car-icon" />
                    80+ véhicules
                  </span>
                </div>
              </div>

              <div className="contact-main">
                <div className="contact-card primary-card">
                  <div className="card-header">
                    <div className="card-icon">📍</div>
                    <h3>Nous Rendre Visite</h3>
                  </div>
                  <div className="card-content">
                    <p className="address-line">72 Avenue Gustave Eiffel</p>
                    <p className="address-line">37390 Notre Dame D'Oé</p>
                    <div className="address-details">
                      <span className="detail-item">📍 Proche de Tours</span>
                      <span className="detail-item">🅿️ Parking gratuit</span>
                    </div>
                  </div>
                </div>

                <div className="contact-card">
                  <div className="card-header">
                    <div className="card-icon">📞</div>
                    <h3>Nous Contacter</h3>
                  </div>
                  <div className="card-content">
                    <a href="tel:0247540186" className="contact-action">
                      02 47 54 01 86
                    </a>
                    <p className="contact-note">Réponse rapide et conseil personnalisé</p>
                  </div>
                </div>

                <div className="contact-card">
                  <div className="card-header">
                    <div className="card-icon">✉️</div>
                    <h3>Nous Écrire</h3>
                  </div>
                  <div className="card-content">
                    <a href="mailto:fdp-automobiles@live.fr" className="contact-action email-action">
                      fdp-automobiles@live.fr
                    </a>
                    <p className="contact-note">Votre demande sera traitée rapidement</p>
                  </div>
                </div>
              </div>

              <div className="contact-schedule">
                <h3>
                  <span className="schedule-icon">🕒</span>
                  Horaires d'ouverture
                </h3>
                <div className="schedule-grid">
                  <div className="schedule-item">
                    <span className="schedule-day">Lundi - Vendredi</span>
                    <span className="schedule-time">10h-12h • 14h-18h30</span>
                  </div>
                  <div className="schedule-item">
                    <span className="schedule-day">Samedi</span>
                    <span className="schedule-time">10h-12h • 14h-16h</span>
                  </div>
                  <div className="schedule-item weekend">
                    <span className="schedule-day">Dimanche</span>
                    <span className="schedule-time">Fermé</span>
                  </div>
                </div>
              </div>

              <div className="contact-footer">
                <div className="contact-cta">
                  <p>Besoin d'un renseignement ?</p>
                  <div className="cta-buttons">
                    <a href="tel:0247540186" className="btn btn-primary">
                      <span className="btn-icon">📞</span>
                      Contactez-nous maintenant
                    </a>
                    <a href="mailto:fdp-automobiles@live.fr" className="btn btn-secondary">
                      <span className="btn-icon">✉️</span>
                      Envoyer un email
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Header; 